import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "NKT-P3 text"
}
const _hoisted_2 = ["src"]

import star from '@/assets/svg/star.svg'



export default /*@__PURE__*/_defineComponent({
  __name: 'ComingIndicator',
  props: {
  isExpanded: Boolean
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container", { expanded: __props.isExpanded, collapsed: !__props.isExpanded }])
  }, [
    (__props.isExpanded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Coming"))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          style: {"vertical-align":"baseline"},
          src: _unref(star)
        }, null, 8, _hoisted_2))
  ], 2))
}
}

})